import { render } from "./contenidoPonentes.vue?vue&type=template&id=6e215a21"
import script from "./contenidoPonentes.vue?vue&type=script&lang=js"
export * from "./contenidoPonentes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__